import { useLocale, useTranslations } from 'next-intl';
import { Option } from 'types/Option';
import { sortByLocale } from 'utils/sortingMethods';

interface IUseOptionsTransactionTypesIn {
  noAny?: boolean;
}

interface IUseOptionsTransactionTypesOut {
  optionsTransactionTypes: Option[];
}

export const TransactionTypesConst = [
  'payment',
  'payment_refund',
  'purchase',
  'purchase_refund',
  'currency_change',
  'manual_credit',
  'manual_debit'
];

export default function useOptionsTransactionTypes(
  { noAny }: IUseOptionsTransactionTypesIn = { noAny: false }
): IUseOptionsTransactionTypesOut {
  const t = useTranslations();
  const locale = useLocale();

  const optionsTransactionTypesInitial = noAny
    ? []
    : [{ label: t('ordering_form.qualities.any'), value: undefined }];

  const optionsTransactionTypes =
    [
      ...optionsTransactionTypesInitial,
      ...TransactionTypesConst?.reduce(
        (acc, value) => [
          ...acc,
          { label: t(`billing.transaction_types.${value}` as any), value: value }
        ],
        [] as Option[]
      ).sort((first, second) => sortByLocale(locale)(first.label, second.label))
    ] ?? optionsTransactionTypesInitial;

  return { optionsTransactionTypes };
}
